import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    vendorNameTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },containerDate:{
      display:'flex',
      flexDirection:'column'
    }
  };
});
